import { ResidencyStatus } from '@nib/phi-constants';
import React from 'react';
import { AddFunnelPropFromContext } from '../funnel-context';
import YesNoRadio from '../yes-no-radio';
const LABEL = 'Choose your type of cover';
export const OPTIONS = {
  [ResidencyStatus.AustralianCitizen]: 'Australian Resident Health Cover',
  [ResidencyStatus.OverseasVisitor]: 'Overseas Visitor Health Cover'
};
const ResidencyStatusRadio = _ref => {
  let {
    options = OPTIONS,
    label = LABEL,
    ...props
  } = _ref;
  return React.createElement(YesNoRadio, {
    ...props,
    options: options,
    label: label
  });
};
const ResidencyStatusRadioWithFunnel = props => React.createElement(AddFunnelPropFromContext, null, React.createElement(ResidencyStatusRadio, {
  ...props
}));
export default ResidencyStatusRadioWithFunnel;